import { useParams, Navigate } from "react-router-dom";
import CityParis from "@/pages/cities/CityParis";
import CityLyon from "@/pages/cities/CityLyon";
import CityMarseille from "@/pages/cities/CityMarseille";
import CityBordeaux from "@/pages/cities/CityBordeaux";
import CityLille from "@/pages/cities/CityLille";

const MAP = {
  paris: CityParis,
  lyon: CityLyon,
  marseille: CityMarseille,
  bordeaux: CityBordeaux,
  lille: CityLille,
};

export default function City() {
  const { slug } = useParams();
  const Comp = MAP[slug];
  if (!Comp) return <Navigate to="/villes/paris" replace />;
  return <Comp />;
}
